import { makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(10, 4),
    gap: theme.spacing(4),
    background:
      'linear-gradient(180deg, #F7FBF8 0%, #FFFFFF 45%, #F7FBF8 100%)',
  },
  hero: {
    textAlign: 'center',
    maxWidth: 760,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    backgroundColor: '#E8F7EF',
    color: '#007A3D',
    border: '1px solid #BFE8CF',
    borderRadius: 999,
    padding: theme.spacing(0.75, 2),
    fontSize: '0.85rem',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: '2.8rem',
    lineHeight: 1.1,
    fontWeight: 800,
    color: '#1F1F1F',
    textAlign: 'center',
    marginBottom: theme.spacing(1.5),
  },
  titleAccent: {
    color: '#00AE58',
  },
  subtitle: {
    fontSize: '1.15rem',
    lineHeight: 1.55,
    color: '#5F6B63',
    textAlign: 'center',
    maxWidth: 680,
    margin: '0 auto',
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    backgroundColor: '#FFFFFF',
    border: '2px solid #D7EBDD',
    borderRadius: 14,
    padding: theme.spacing(1.5, 2),
    width: '100%',
    maxWidth: 620,
    cursor: 'pointer',
    textDecoration: 'none',
    boxShadow: '0 8px 22px rgba(0, 174, 88, 0.08)',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: '#00AE58',
      boxShadow: '0 10px 26px rgba(0, 174, 88, 0.16)',
      transform: 'translateY(-1px)',
    },
  },
  searchIcon: {
    color: '#00AE58',
  },
  searchText: {
    color: '#5F6B63',
    fontSize: '1rem',
    fontWeight: 500,
  },
  cardGrid: {
    display: 'flex',
    gap: theme.spacing(3.5),
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
  card: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #D7EBDD',
    borderRadius: 18,
    padding: theme.spacing(3.5),
    width: 245,
    minHeight: 145,
    textAlign: 'center',
    cursor: 'pointer',
    textDecoration: 'none',
    color: '#1F1F1F',
    boxShadow: '0 8px 22px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s ease',
    position: 'relative',
    overflow: 'hidden',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 5,
      backgroundColor: '#00AE58',
      opacity: 0,
      transition: 'opacity 0.2s ease',
    },
    '&:hover': {
      borderColor: '#00AE58',
      transform: 'translateY(-4px)',
      boxShadow: '0 14px 30px rgba(0, 174, 88, 0.14)',
    },
    '&:hover:before': {
      opacity: 1,
    },
  },
  cardIcon: {
    width: 46,
    height: 46,
    margin: '0 auto',
    marginBottom: theme.spacing(2),
    borderRadius: 14,
    backgroundColor: '#E8F7EF',
    color: '#007A3D',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.35rem',
    fontWeight: 800,
  },
  cardTitle: {
    fontWeight: 800,
    fontSize: '1.08rem',
    marginBottom: theme.spacing(1),
    color: '#007A3D',
  },
  cardDesc: {
    fontSize: '0.92rem',
    lineHeight: 1.4,
    color: '#5F6B63',
  },
}));

export const HomePage = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.hero}>
        <div className={classes.badge}>Acme API Hub</div>

        <div className={classes.title}>
          Welcome to the{' '}
          <span className={classes.titleAccent}>Acme</span> API Portal
        </div>

        <div className={classes.subtitle}>
          Discover, manage, and onboard trusted digital services that support
          Acme teams, members, and partners.
        </div>
      </div>

      <a href="/search" className={classes.searchBox}>
        <SearchIcon className={classes.searchIcon} />
        <span className={classes.searchText}>Search for APIs, docs, and services...</span>
      </a>

      <div className={classes.cardGrid}>
        <a href="/api-docs" className={classes.card}>
          <div className={classes.cardIcon}>API</div>
          <div className={classes.cardTitle}>API Catalog</div>
          <div className={classes.cardDesc}>
            Explore approved APIs and service documentation.
          </div>
        </a>

        <a href="/catalog-import" className={classes.card}>
          <div className={classes.cardIcon}>+</div>
          <div className={classes.cardTitle}>Add New API</div>
          <div className={classes.cardDesc}>
            Onboard a new API to the Acme portal.
          </div>
        </a>

        <a href="/doc" className={classes.card}>
          <div className={classes.cardIcon}>?</div>
          <div className={classes.cardTitle}>Project Guide</div>
          <div className={classes.cardDesc}>
            Learn how to set up, publish, and manage APIs.
          </div>
        </a>
      </div>
    </div>
  );
};